@if (loading) {
  <button
    mat-button  [disabled]="true">
    <mat-icon>
      <mat-spinner [diameter]="20"></mat-spinner>
    </mat-icon>
  </button>
} @else {
  <ng-content>
  </ng-content>
}
